import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Options } from 'components/Options/Options'
import { Td } from 'components/Td/Td'
import {
  Button,
  Flex,
  H1WithBack,
  PageWrapper,
  Table,
  Th,
  Tr,
} from 'styling/GlobalStyles'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import {
  clearAttendanceDevices,
  deleteAttendanceDevice,
  getAttendanceDevices,
} from 'features/attendance/attendanceSlice'
import { IAttendanceDevice } from 'types/api/attendanceApi.interface'
import { setConfirmModal } from 'features/global/globalSlice'
import { AttendanceDeviceModal } from './AttendanceDeviceModal'

export const AttendanceDevices = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { devices } = useSelector((state: RootState) => state.attendance)
  const [modal, setModal] = useState<{ open: boolean; value: IAttendanceDevice | null }>({
    open: false,
    value: null,
  })

  useEffect(() => {
    dispatch(getAttendanceDevices())
    return () => {
      dispatch(clearAttendanceDevices())
    }
  }, [])

  const handleDelete = (id: number) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteAttendanceDevice(id))
        },
        word: 'delete attendance device',
      }),
    )
  }

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between center mb='16'>
          <H1WithBack arrow title='Attendance Devices' />
          <Button orange onClick={() => setModal({ open: true, value: null })}>
            Add Device
          </Button>
        </Flex>
        {!devices?.length ? (
          <NoData />
        ) : (
          <Table>
            <Th>
              <Td w='25%' noTooltip text='NAME' />
              <Td w='20%' noTooltip text='SERIAL' />
              <Td w='15%' noTooltip text='LOCATION' />
              <Td w='10%' noTooltip text='ACTIVE' />
              <Td w='25%' noTooltip text='TOKEN' />
              <Td w='5%' />
            </Th>
            {devices.map((item) => (
              <Tr key={item.id}>
                <Td w='25%' noTooltip text={item.name} />
                <Td w='20%' noTooltip text={item.serialNumber || '-'} />
                <Td w='15%' noTooltip text={item.locationId ? String(item.locationId) : '-'} />
                <Td w='10%' noTooltip text={item.isActive ? 'Yes' : 'No'} />
                <Td w='25%' noTooltip text={item.secretToken} />
                <Td options w='5%'>
                  <Options
                    item={item}
                    title='Attendance Device'
                    openModal={() => setModal({ open: true, value: item })}
                    handleRemove={handleDelete}
                  />
                </Td>
              </Tr>
            ))}
          </Table>
        )}
      </PageWrapper>
      {modal.open ? (
        <AttendanceDeviceModal closeModal={() => setModal({ open: false, value: null })} value={modal.value} />
      ) : null}
    </>
  )
}
